module.exports = __webpack_public_path__ + "img/user-bg.6ebd2885.png";